module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uix-panel"
  }, [_c('div', {
    staticClass: "uix-panel-header",
    class: {
      collapsible: _vm.collapsible, show: _vm.show
    },
    on: {
      "click": _vm.tooglePanel
    }
  }, [_c('div', {
    staticClass: "uix-panel-actions"
  }, [_vm._t("actions")], 2), _vm._v(" "), _vm._t("header")], 2), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "uix-panel-body"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-415fb994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/Panel.vue
// module id = 249
// module chunks = 0